import React, {ReactNode} from "react"
import {Button, Modal} from "xps-react";

export interface ModalWrapperProps {
    id: string;
    headerText: string | ReactNode;
    subHeaderText?: string | ReactNode;
    isOpen?: boolean;
    size?: string;
    alertIcon?: string,
    alertIconType?: string,
    showCloseButton?: boolean;
    buttons?: ModalButton[];
    onRequestClose?: () => void;
    dataTestId?: string;
}

export interface ModalButton {
    datatestid?: string;
    text: string | ReactNode;
    primary?: boolean;
    onClick?: () => void;
    destructive?: boolean;
    ariaLabel?: string;
    className?: string;
    iconPosition?: string;
    iconName?: string;
    disabled?: boolean;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({
                                                       id,
                                                       headerText,
                                                       subHeaderText,
                                                       isOpen,
                                                       size = "small",
                                                       alertIcon,
                                                       alertIconType,
                                                       showCloseButton = false,
                                                       buttons = [],
                                                       children,
                                                       onRequestClose,
                                                       dataTestId,
                                                   }) => {
    const getCssClassName = (button: ModalButton) => {
        let className = `marginright-12 ${button.className}`.trim();

        if (button.destructive) {
            className += ' modal-wrapper-container button--destructive btn-skin--primary';
        }

        return className;
    };

    const headerWithSubheader = (
        <div>
            <h1 className="h3 display-inlineblock">{headerText}</h1>
            {subHeaderText && <p className="modal-sub-header">{subHeaderText}</p>}
        </div>
    )

    return (
        <Modal
            ariaLabel="model-test"
            alertIcon={alertIcon}
            alertIconType={alertIconType}
            header={subHeaderText ? headerWithSubheader : headerText}
            label="modal-label"
            id={id}
            size={size}
            isOpen={isOpen}
            showCloseButton={showCloseButton}
            footer={
                <>
                    {buttons.map((button, index) => (
                        <Button
                            data-testid={button.datatestid}
                            aria-label={button.ariaLabel}
                            className={getCssClassName(button)}
                            destructive={button.destructive}
                            disabled={button.disabled}
                            key={index}
                            kind={button.primary ? 'primary' : 'secondary'}
                            onClick={button.onClick}
                            size="medium"
                            icon={button.iconPosition}
                            iconName={button.iconName}
                        >
                            {button.text}
                        </Button>
                    ))}
                </>
            }
            onRequestClose={onRequestClose}
        >
            {children}
        </Modal>
    );
}

export default ModalWrapper;
